<template>
  <div id="app">
    <template v-if="!loading">
      <router-view />
    </template>
  </div>
</template>

<script>
import config from "@/config";
import queryString from "query-string";
export default {
  data() {
    return {
      text: "",
      loading: true,
    };
  },
  async beforeCreate() {
    var vm = this;

    try {
      // eslint-disable-next-line
      var liffId = "";
      var query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;

      if (query.pageid == "326180737483767") {
        liffId = "1655568097-W8ObG43P";
      } else {
        liffId = config.getConfig("liffId");
      }
      await this.$liff.init({
        liffId: liffId,
      });
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
    this.loading = false;
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./assets/css/style.scss";
html {
  height: 100vh;
}
</style>
